import type { TFunction } from 'i18next';
import { BillingToggleLabels } from './BillingToggleSection';

export const buildBillingLabels = (
  t: TFunction,
  baseKey: string
): BillingToggleLabels => {
  const BILLING = `${baseKey}.credentialsStep.billing`;

  return {
    migrationTitle: t(`${BILLING}.MIGRATION_TITLE`),
    migrationBody: t(`${BILLING}.MIGRATION_BODY`)
  };
};
